import { Injectable } from "@angular/core";
import { envSettings } from "@ami/angular/core/env-settings";

export const nxApiBaseUrl: string = envSettings('NX_API_BASE_URL')!;
export const showTestBanner: boolean = JSON.parse(envSettings('NX_APP_SHOW_TEST_BANNER', { optional: true }) ?? 'false');
export const applicationInsightsInstrumentationKey: string = envSettings('NX_REACT_APP_APP_INSIGHTS_KEY', { optional: true }) ?? '';
export const appVersion: string = envSettings('NX_REACT_APP_AMI_VERSION', { optional: true }) ?? '';

@Injectable({
  providedIn: 'root'
})
export class AppSettings {
  readonly showTestBanner: boolean = showTestBanner;
  readonly nxApiBaseUrl = nxApiBaseUrl;
}
